import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "./constants";
const bonuses = [{
  n: 1,
  img: IMAGES.bono1,
  title: "Calculadora de Pérdidas por Refinamiento™",
  value: "USD $37",
  desc: "Descubre cuánto dinero está perdiendo realmente tu consulta cada vez que un tratamiento requiere un refinamiento, considerando tiempo clínico, citas adicionales y pérdida de rentabilidad."
}, {
  n: 2,
  img: IMAGES.bono2,
  title: "Guía Express de Correcciones Clínicas™",
  value: "USD $47",
  desc: "Cuando un movimiento deja de expresarse correctamente no siempre necesitas nuevos alineadores. Aplica protocolos de rescate, ajustes clínicos y maniobras para recuperar el control."
}, {
  n: 3,
  img: IMAGES.bono3,
  title: "Scripts Profesionales para Pacientes™",
  value: "USD $27",
  desc: "Reduce reclamos, mejora la comunicación y establece expectativas realistas desde la primera consulta. Incluye mensajes listos para usar en consulta y por WhatsApp."
}, {
  n: 4,
  img: IMAGES.bono4,
  title: "Checklist Maestro para Aprobar ClinChecks™",
  value: "USD $37",
  desc: "Antes de hacer clic en “Aceptar”, revisa esta lista de puntos críticos. Una herramienta sencilla que puede ayudarte a detectar errores antes de iniciar el tratamiento."
}, {
  n: 5,
  img: IMAGES.bono5,
  title: "Plantillas de Consentimiento y Documentos™",
  value: "USD $37",
  desc: "Documentos listos para usar que protegen tu clínica, ayudan a cumplir la normativa vigente y ahorran tiempo con plantillas profesionales editables."
}];
export function Bonuses() {
  return <section className="bg-white px-5 py-12" data-id="element-29" data-mp="38e5upkchz1m7">
      <div className="mx-auto max-w-md" data-id="element-30" data-mp="33gw6u94ray0h">
        <div className="text-center" data-id="element-31" data-mp="33fukh8iaip3g">
          <div className="mb-2 text-3xl" data-id="element-32" data-mp="nprktagz6tm7">🎁</div>
          <h2 className="font-display text-2xl font-extrabold leading-tight text-navy-800 sm:text-3xl" data-id="element-33" data-mp="noggn9jmbjuk">
            Además recibirás <span className="text-brand" data-id="element-34" data-mp="itawaf5v6d8l">GRATIS</span> estas 5 Herramientas Clínicas
          </h2>
          <p className="mt-3 text-sm text-navy-800/60" data-id="element-35" data-mp="3cl0wnc2kaqlj">
            No son archivos de relleno. Son recursos que utilizarás durante tu práctica clínica.
          </p>
        </div>

        <div className="mt-6 space-y-4" data-id="element-36" data-mp="3lke45z74l53m">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="overflow-hidden rounded-2xl border border-navy-100 bg-navy-50" data-id="element-37" data-mp="3qhebedfpodwb" data-mpi={i}>
              {b.img && <div className="flex justify-center bg-white px-2 pt-4 sm:px-4" data-id="element-38" data-mp="37jjuld8ccy3d">
                  <img src={b.img} alt={b.title} className="h-64 max-w-full w-auto object-contain drop-shadow-xl sm:h-72" data-id="element-39" data-mp="37lo9srboxjiy" />
                </div>}
              <div className="p-5" data-id="element-40" data-mp="27k9offvy8ei5">
                <div className="mb-2 flex flex-wrap items-center gap-2" data-id="element-41" data-mp="27j8a92jmzbw7">
                  <span className="rounded-full bg-brand px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-42" data-mp="22ly9iqqsrdt2">
                    Bono #{b.n}
                  </span>
                  <span className="rounded-full bg-navy-800/5 px-2.5 py-1 text-[11px] font-bold text-navy-800" data-id="element-43" data-mp="1tl090ifkhof8">
                    Valor: <s className="text-navy-800/50" data-id="element-44" data-mp="1omqabxumw5ov">{b.value}</s>
                  </span>
                </div>
                <h3 className="font-display text-base font-bold leading-snug text-navy-800" data-id="element-45" data-mp="1jt470wad1e5q">{b.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-navy-800/60" data-id="element-46" data-mp="1evlyv84632ys">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}